module.exports = __webpack_public_path__ + "static/media/home-app-image.cd9b5079.png";